<template>
  <div>
    <div class="wrapper wrapper-content" v-if="statsLoaded">
      <div class="row">
        <div class="col-lg-3">
          <div class="ibox ">
            <div class="ibox-title">
              <span class="label label-success float-right">Active</span>
              <h5>Sites</h5>
            </div>
            <div class="ibox-content">
              <h1 class="no-margins">{{ stats.activeSites }}</h1>
              <!-- <div class="stat-percent font-bold text-success">98% <i class="fa fa-bolt"></i></div> !-->
              <small>All active sites</small>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="ibox ">
            <div class="ibox-title">
              <span class="label label-success float-right">Active</span>
              <h5>Loaders</h5>
            </div>
            <div class="ibox-content">
              <h1 class="no-margins">{{ stats.activeLoadersSum }}</h1>
              <!-- <div class="stat-percent font-bold text-success">98% <i class="fa fa-bolt"></i></div> !-->
              <small>All active loaders</small>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="ibox ">
            <div class="ibox-title">
              <span class="label label-info float-right">New</span>
              <h5>Loaders</h5>
            </div>
            <div class="ibox-content">
              <h1 class="no-margins">{{ stats.newLoaders }}</h1>
              <div class="stat-percent font-bold text-info">{{ Math.round((stats.newLoaders / (stats.activeLoadersSum - stats.newLoaders))  * 100) }}% <i class="fa fa-level-up"></i></div>
              <small>Loaders added today</small>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="ibox ">
            <div class="ibox-title">
              <span class="label label-danger float-right">Lost</span>
              <h5>Loaders</h5>
            </div>
            <div class="ibox-content">
              <h1 class="no-margins">{{ stats.lostLoaders }}</h1>
              <!--<div class="stat-percent font-bold text-navy">44% <i class="fa fa-level-up"></i></div>-->
              <small>Loaders lost today</small>
            </div>
          </div>
        </div>
        <!--<div class="col-lg-3">-->
          <!--<div class="ibox ">-->
            <!--<div class="ibox-title">-->
              <!--<span class="label label-danger float-right">Low value</span>-->
              <!--<h5>User activity</h5>-->
            <!--</div>-->
            <!--<div class="ibox-content">-->
              <!--<h1 class="no-margins">80,600</h1>-->
              <!--&lt;!&ndash;<div class="stat-percent font-bold text-danger">38% <i class="fa fa-level-down"></i></div>&ndash;&gt;-->
              <!--<small>In first month</small>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox ">
            <div class="ibox-title">
              <h5>Loaders</h5>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-lg-9">
                </div>
                <div class="col-lg-3">
                  <ul class="stat-list">
                    <li v-for="(loader, cnt) in stats.activeLoaders" v-bind:key="loader">
                      <h2 class="no-margins">{{ loader }}</h2>
                      <small>&nbsp;</small>
                      <div class="stat-percent">{{ cnt }} <!--<i class="fa fa-level-up text-navy"></i>!--></div>
                      <div class="progress progress-mini">
                        <div v-bind:style="{ width: loader / stats.activeLoadersSum * 100 + '%' }" class="progress-bar"></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox ">
            <div class="ibox-title">
              <h5>Top Languages</h5>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-lg-9">
                </div>
                <div class="col-lg-3">
                  <ul class="stat-list">
                    <li v-for="(lang) in stats.langCount" v-bind:key="lang.locale">
                      <h2 class="no-margins">{{ lang.langName }}</h2>
                      <small>&nbsp;</small>
                      <div class="stat-percent">{{ lang.count }} <!--<i class="fa fa-level-up text-navy"></i>!--></div>
                      <div class="progress progress-mini">
                        <div style="width: 48%;" class="progress-bar"></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      name: 'Stats',
      statsLoaded: false,
      stats: {}
    }
  },
  mounted () {
    this.getSystemStats()
  },
  methods: {
    getSystemStats () {
      axios.get(process.env.API + '/system-stats')
        .then(response => {
          this.stats = response.data
          this.statsLoaded = true
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Stats/Stats.vue